module.exports = __webpack_public_path__ + "media/images/career_camp/2023/icon-chevron-a7ea0b7327048f394fb9c160418f1fe9.svg";